import { render, staticRenderFns } from "./Internal-Contracts.vue?vue&type=template&id=195b93c4&scoped=true"
import script from "./Internal-Contracts.vue?vue&type=script&lang=js"
export * from "./Internal-Contracts.vue?vue&type=script&lang=js"
import style0 from "./Internal-Contracts.vue?vue&type=style&index=0&id=195b93c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195b93c4",
  null
  
)

export default component.exports